import { Button, Icon, Menu, MenuButton, MenuItem, MenuList } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { FaInbox, FaPaperPlane, FaPlus, FaShoppingBasket } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useCreateSourcingEventMutation } from "../../../../autogen/bff-api";
import { urls } from "../../../../urls";
import { useLoggedInWithOrgContextState } from "../../../auth/useLoggedInWithOrgContextState";
import { useApiError } from "../../../errors/useApiError";
import { useSub } from "../../../subscription/useSub";
import { Explanation } from "../../../support/Explanation/Explanation";

export const Sourcing = () => {
  const navigate = useNavigate();
  const authState = useLoggedInWithOrgContextState();
  const { t } = useTranslation();
  const sub = useSub();
  const { trigger } = useApiError();
  const [createSourcingEvent, { isLoading: isCreating }] = useCreateSourcingEventMutation();
  const canCreateEvent = authState.selectedOrg.canCreateEvent;

  const handleCreate = async () => {
    try {
      const event = await createSourcingEvent({
        createSourcingEventV2Request: { title: "" },
      }).unwrap();
      navigate(urls.publicEvents.edit.go(event.id).info);
    } catch (e) {
      trigger(e);
    }
  };

  return (
    <>
      {sub.hasBuyerAccess && (
        <>
          <Menu>
            <MenuButton
              as={Button}
              leftIcon={<Icon as={FaShoppingBasket} w="15px" h="15px" />}
              colorScheme="teal"
              variant="ghost"
              size={"sm"}
            >
              {t("Sourcing")}
            </MenuButton>
            <MenuList>
              <Explanation
                enabled={!canCreateEvent}
                placement={"left-start"}
                text={t("Only admins and creators can create new events")}
              >
                <MenuItem
                  isDisabled={!canCreateEvent || isCreating}
                  icon={<Icon as={FaPlus} w="15px" h="15px" marginBottom={-0.5} />}
                  onClick={handleCreate}
                >
                  {t("New event")}
                </MenuItem>
              </Explanation>
              <MenuItem
                icon={<Icon as={FaShoppingBasket} w="15px" h="15px" marginBottom={-0.5} />}
                onClick={() => {
                  navigate(urls.events.viewAll);
                }}
              >
                {t("All sourcing events")}
              </MenuItem>
            </MenuList>
          </Menu>
          <Menu>
            <MenuList>
              <MenuItem
                icon={<Icon as={FaPaperPlane} w="15px" h="15px" marginBottom={-0.5} />}
                onClick={() => {
                  navigate(urls.bids.viewAll);
                }}
              >
                {t("Delivered bids")}
              </MenuItem>
              <MenuItem
                icon={<Icon as={FaInbox} w="15px" h="15px" marginBottom={-0.5} />}
                onClick={() => {
                  navigate(urls.bids.received);
                }}
              >
                {t("Received bids")}
              </MenuItem>
            </MenuList>
          </Menu>
        </>
      )}
      {!sub.hasBuyerAccess && (
        <>
          <Menu>
            <MenuButton
              as={Button}
              leftIcon={<Icon as={FaShoppingBasket} w="15px" h="15px" />}
              colorScheme="teal"
              variant="ghost"
              size={"sm"}
            >
              {t("Bids")}
            </MenuButton>
            <MenuList>
              <MenuItem
                icon={<Icon as={FaInbox} w="15px" h="15px" marginBottom={-0.5} />}
                onClick={() => navigate(urls.events.viewInvitations)}
              >
                {t("Bid invitations")}
              </MenuItem>
              <MenuItem
                icon={<Icon as={FaPaperPlane} w="15px" h="15px" marginBottom={-0.5} />}
                onClick={() => navigate(urls.bids.viewAll)}
              >
                {t("Delivered bids")}
              </MenuItem>
            </MenuList>
          </Menu>
        </>
      )}
    </>
  );
};
